import React from 'react'
import {
  StepItem,
  StepList,
  Steps,
  StepsContent,
} from '@lightspeed/unified-components-helios-theme/react'
import { STEPS } from '../types'
import { useStepBreadcrumbsModel } from './useStepBreadcrumbsModel'

export interface StepBreadcrumbsProps {
  step: STEPS
  isAddingCustomer?: boolean
  onStepChange?: (step: STEPS) => void
  children?: React.ReactNode
}

export const StepBreadcrumbs: React.FC<StepBreadcrumbsProps> = props => {
  const models = useStepBreadcrumbsModel(props)
  const steps = props.isAddingCustomer
    ? [STEPS.METHOD, STEPS.CUSTOMER, STEPS.ADD, STEPS.DETAILS]
    : [STEPS.METHOD, STEPS.CUSTOMER, STEPS.DETAILS]

  const handleStepChange = (index: number) => {
    const step = steps[index]
    if (step) props.onStepChange?.(step)
  }

  return (
    <div className="uc-base pt-8 pb-8">
      <Steps
        appearance="progress"
        count={models.breadcrumbs.length}
        step={models.activeStep}
        linear={false}
        onStepChange={handleStepChange}
        titleSlot={`Step ${models.activeStep + 1}/${
          models.breadcrumbs.length
        }: ${models.breadcrumbs[models.activeStep]}`}
        customClasses={{ title: 'pl-8 pr-16' }}
      >
        <div className="px-8">
          <StepList customClasses={{ root: 'gap-1 overflow-visible' }}>
            {models.breadcrumbs.map((breadcrumb, index) => (
              <StepItem
                key={breadcrumb}
                index={index}
                customClasses={{ root: 'me-0' }}
              />
            ))}
          </StepList>
        </div>
        <StepsContent index={models.activeStep}>{props.children}</StepsContent>
      </Steps>
    </div>
  )
}
